<template>
  <div class="masker">
    <transition name="fade" appear>
      <div class="alert">
        <div class="title" v-show="title">{{title}}</div>
        <div class="content" v-html="content"></div>
        <div class="btns">
          <div class="btn" v-show="btnLeft"  :style="btnLeftStyle" @click="confirm">
            {{btnLeft}}
          </div>
          <div class="btn" v-show="btnRight" :style="btnRightStyle" @click="cancel">
            {{btnRight}}
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Alert',
  data() {
    return {
      title:  "",
      content:  "",
      btnLeft:  "确定",
      btnLeftStyle: "",
      btnLeftClick: () => {},
      btnRight:  "",
      btnRightStyle: "",
      btnRightClick: () => {}
    }
  },
  methods: {
    confirm() {
      this.hide();
      this.btnLeftClick && this.btnLeftClick();
    },
    cancel() {
      this.hide();
      this.btnRightClick && this.btnRightClick();
    },
    hide() {
      document.body.removeChild(this.$el);
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/dialog/Alert.vue